import React from "react";

import { securityService } from "../../../jwt/_services";
import { setSupervisors } from "../generalActions/selectorsActions";

export const getSupervisors = () => ( dispatch ) => securityService.listSupervisors()
    .then(result => dispatch( setSupervisors(result ? getOptions(result) : null) ) )
    .catch( console.log )

const getOptions = supervisors => supervisors.map(supervisor =>({
    id: supervisor?.id,
    value: supervisor?.id,
    label: <label>{supervisor?.name} {supervisor?.lastName}</label>
}))